<template>
  <div class="password-reset-page">
    <header-pane :pageTitle="$tc('LoginPage.pageTitle')" colorType="light" />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'

/**
 * パスワードリセット ページ
 */
export default defineComponent({
  name: 'PasswordResetPage',
  components: {
    HeaderPane,
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.password-reset-page {
  background: $gray1;
  min-height: var(--screen-height);
}
</style>

<style lang="scss">
.password-reset-page {
  .password-reset-mail-input-section__send-mail-btn {
    margin-top: 24px;
  }

  .password-reset-mail-input-pane,
  .password-reset-mail-sent-pane,
  .password-reset-new-password-pane,
  .password-reset-complete-pane {
    height: auto;
    max-width: 800px;
    min-height: calc(100vh - #{$headerPaneHeight} - #{$subHeaderPaneHeight});
    padding-bottom: 136px;
    background: none;
    margin: 0 auto;
  }
}
</style>
